export interface CourseDef {
  id: string;
  name: string;
  group: "Mandatory" | "Clinical" | "Development" | "Role Specific";
  months: number;
  roles?: string[];
}

const c = (id: string, name: string, group: CourseDef["group"], months: number, roles?: string[]): CourseDef => ({ id, name, group, months, roles });

export const COURSES: CourseDef[] = [
  c("safeguarding-adults", "Safeguarding Adults (Level 2)", "Mandatory", 12),
  c("fire-safety", "Fire Safety Awareness", "Mandatory", 12),
  c("health-safety", "Health and Safety", "Mandatory", 12),
  c("ipc", "Infection Prevention and Control", "Mandatory", 12),
  c("moving-handling", "Moving and Handling of People", "Mandatory", 12),
  c("first-aid", "First Aid and Basic Life Support", "Mandatory", 12),
  c("medication-awareness", "Medication Awareness and Administration", "Mandatory", 12),
  c("coshh", "COSHH Awareness", "Mandatory", 12),
  c("data-protection", "Data Protection, GDPR and Confidentiality", "Mandatory", 24),
  c("equality", "Equality, Diversity and Human Rights", "Mandatory", 24),
  c("whistleblowing", "Whistleblowing and Raising Concerns", "Mandatory", 24),
  c("mca-dols", "MCA and DoLS", "Mandatory", 24),
  c("dementia", "Dementia Care", "Mandatory", 24),
  c("oliver-mcgowan", "Oliver McGowan Mandatory Training (Learning Disability and Autism)", "Mandatory", 12),
  c("duty-candour", "Duty of Candour and Openness", "Mandatory", 24),
  c("record-keeping", "Record Keeping and Documentation", "Mandatory", 24),
  c("care-certificate", "Care Certificate (15 Standards)", "Mandatory", 0),
  c("induction", "Induction and Orientation", "Mandatory", 0),
  c("pressure-care", "Pressure Ulcer Prevention and Skin Integrity", "Clinical", 24),
  c("falls", "Falls Prevention and Response", "Clinical", 24),
  c("nutrition", "Nutrition, Hydration and Dysphagia Awareness", "Clinical", 24),
  c("oral-care", "Oral Care", "Clinical", 24),
  c("eol", "End of Life and Palliative Care", "Clinical", 24),
  c("diabetes", "Diabetes Care and Management", "Clinical", 24),
  c("sepsis", "Sepsis Awareness", "Clinical", 24),
  c("wound-care", "Wound Care and Dressings", "Clinical", 24),
  c("continence", "Continence Management", "Clinical", 24),
  c("catheter-care", "Catheter Care", "Clinical", 24),
  c("peg-care", "PEG Feeding and Care", "Clinical", 24),
  c("epilepsy", "Epilepsy and Buccal Midazolam", "Clinical", 12),
  c("stroke", "Stroke Awareness", "Clinical", 24),
  c("pain", "Pain Management", "Clinical", 24),
  c("mental-health", "Mental Health Awareness", "Clinical", 24),
  c("food-hygiene", "Food Hygiene (Level 2)", "Role Specific", 36, ["Kitchen"]),
  c("food-safety-kitchen", "Food Safety Management for Kitchens", "Role Specific", 36, ["Kitchen"]),
  c("fire-marshal", "Fire Marshal Training", "Role Specific", 24, ["Manager", "Deputy Manager", "Senior Carer"]),
  c("safeguarding-l3", "Safeguarding Adults Level 3 (Leads)", "Role Specific", 24, ["Manager", "Deputy Manager", "Nurse"]),
  c("first-aid-work", "Emergency First Aid at Work", "Role Specific", 36, ["Manager", "Deputy Manager", "Senior Carer", "Maintenance"]),
  c("loler", "LOLER and PUWER Awareness", "Role Specific", 24, ["Maintenance", "Manager", "Senior Carer"]),
  c("legionella", "Legionella and Water Safety Awareness", "Role Specific", 24, ["Maintenance", "Manager", "Domestic"]),
  c("fire-doors", "Fire Door Inspection and Maintenance", "Role Specific", 24, ["Maintenance"]),
  c("ipc-domestic", "Infection Control for the Domestic Environment", "Role Specific", 12, ["Domestic"]),
  c("safer-recruitment", "Safer Recruitment and Interviewing", "Role Specific", 24, ["Manager", "Deputy Manager", "Admin"]),
  c("cqc-readiness", "CQC Readiness and Inspection Training", "Role Specific", 12, ["Manager", "Deputy Manager", "Senior Carer", "Admin"]),
  c("leadership", "Leadership and Management in Care", "Development", 0),
  c("mentoring", "Mentoring, Coaching and Buddy Training", "Development", 0),
  c("train-trainer", "Train the Trainer", "Development", 0),
  c("diploma", "Level 2 or 3 Diploma in Health and Social Care", "Development", 0),
  c("pbs", "Positive Behaviour Support", "Development", 24),
  c("makaton", "Makaton and Communication Methods", "Development", 0),
  c("mhfa", "Mental Health First Aid", "Development", 24),
  c("dementia-champion", "Dementia Champion Training", "Development", 0),
  c("activities", "Activity Coordination and Engagement", "Development", 0),
  c("gdpr-managers", "Data Protection for Managers", "Development", 24, ["Manager", "Deputy Manager", "Admin"]),
];

export function coursesForRole(role: string): CourseDef[] {
  const r = String(role || "").toLowerCase();

  return COURSES.filter(course => {
    if (!course.roles) return true;

    return course.roles.some(item => r.includes(item.toLowerCase()));
  });
}